<!--<img src="assets/img/logo.png" alt="logo" dgRetina src1x="assets/img/logo.png" src2x="assets/img/logo_2x.png" width="78" height="22">-->
<span [ngClass]="['logo', origin === 'sideBarHeader' ? 'logo-text-small' : 'logo-text']">
  <span>DATA</span>
  <span class="second-part">GRO</span>
</span>
